// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleService = Symbol('RoleService');
